(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(90688);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./config.js
var config = __webpack_require__(83346);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
;// CONCATENATED MODULE: ./src/components/homepage/largeCollectionMobileSlider.js





function largeCollectionMobileSlider(props) {
    // console.log("98989", props)
    var settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "50px",
        dots: false,
        arrows: false
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.Z, {
        ...settings,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "large-collection-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/pgvt-calacatta-bellissimo-marmi"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/PGVT Calacatta Bellissimo Marmi - 800x1600.jpg",
                                alt: "PGVT Calacatta Bellissimo Marmi_800x1600 "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                children: [
                                    "PGVT Calacatta Bellissimo Marmi",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "800X1600 mm"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "large-collection-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/pgvt-onyx-pearl"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/PGVT ONYX PEARL - 800x1600.jpg",
                                alt: "PGVT ONYX PEARL "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                children: [
                                    "PGVT ONYX PEARL",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "800X1600 mm"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "large-collection-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/carving-sofita-marble-beige"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/Carving Sofita Marble Beige - 800x1600.jpg",
                                alt: "Carving Sofita Marble Beige - 800x1600 "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                children: [
                                    "Carving Sofita Marble Beige",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "800X1600 mm"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "large-collection-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/granalt-snp-royal-black"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/Granalt SNP Black - 800x2400.jpg",
                                alt: "Granalt SNP Black - 800x2400 mm"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                children: [
                                    "Granalt SNP Black",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "800X2400 mm"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "large-collection-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/granalt-statuario"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/Granalt Statuario - 800x2400.jpg",
                                alt: "Granalt Statuario - 800x2400"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                children: [
                                    "Granalt Statuario",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "800X2400 mm"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "large-collection-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/granalt-galactic-blue"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/Granalt Galactic Blue - 800x2400.jpg",
                                alt: "Granalt Galactic Blue - 800x2400"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                children: [
                                    "Granalt Galactic Blue",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "800X2400 mm"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "large-collection-7",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/pgvt-endless-statuario-marble"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/PGVT Endless Statuario Marble - 1200x1800.jpg",
                                alt: "PGVT Endless Statuario Marble - 1200x1800 "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                children: [
                                    "PGVT Endless Statuario Marble ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "1200X1800 mm"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "large-collection-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/silken-piasentina-stone-grey"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/Silken Piasentina Stone Grey - 1200x1800.jpg",
                                alt: "Silken Piasentina Stone Grey"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                children: [
                                    "Silken Piasentina Stone Grey",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "1200X1800 mm"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "large-collection-9",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/super-gloss-jeriba-quartzite-blue"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/Super Gloss Jeriba Quartzite Blue - 1200x1800.jpg",
                                alt: "Super Gloss Jeriba Quartzite Blue - 1200x1800"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                children: [
                                    "Super Gloss Jeriba Quartzite Blue",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "1200X1800 mm"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "large-collection-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/tiles/large-tiles"),
                        children: [
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/view-all-tiles-black.jpg",
                                alt: "view all tiles image"
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var homepage_largeCollectionMobileSlider = (largeCollectionMobileSlider);

;// CONCATENATED MODULE: ./src/components/homepage/latestTrending.js





function latestTrending(props) {
    var settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "50px",
        dots: false,
        arrows: false
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.Z, {
        ...settings,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "latest-trending-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "/tiles/anti-skid-tiles",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/ANTI SKID TILES.jpg",
                                alt: "ANTI SKID TILES"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                children: "ANTI SKID TILES"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "latest-trending-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "/tiles/cool-tiles",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "COOL ROOF TILES.jpg",
                                alt: "COOL ROOF TILES"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                children: "COOL ROOF TILES"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "latest-trending-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "/tiles/elevation-tiles",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "ELEVATION TILES.jpg",
                                alt: "ELEVATION TILES"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                children: "ELEVATION TILES"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "latest-trending-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "/tiles/highlighter-tiles",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/HIGHLIGHTER TILES.jpg",
                                alt: "HIGHLIGHTER TILES"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                children: "HIGHLIGHTER TILES"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "latest-trending-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "/tiles/forever-tiles",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/SCRATCH FREE TILES.jpg",
                                alt: "SCRATCH FREE TILES"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                children: "SCRATCH FREE TILES(FOREVER TILES)"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "latest-trending-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "/tiles/large-tiles",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/LARGE SLAB TILES.jpg",
                                alt: "LARGE SLAB TILES"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                children: "LARGE SLAB TILES"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "latest-trending-7",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "/tiles/parking-tiles",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/PARKING TILES.jpg",
                                alt: "PARKING TILES"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                children: "PARKING TILES"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "new-collection-bx",
                    id: "latest-trending-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "/tiles/wall-tiles",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/WALL TILES1.jpg",
                                alt: "WALL TILES"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                children: "WALL TILES"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "new-collection-bx",
                id: "latest-trending-9",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                    href: "/tiles",
                    children: [
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/view-all-tiles-black.jpg",
                            alt: "view all tiles image"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var homepage_latestTrending = (latestTrending);

;// CONCATENATED MODULE: ./src/components/homepage/latestTrendingDesktop.js

const tileData = [
    {
        href: "/tiles/anti-skid-tiles",
        src: "/ANTI SKID TILES.jpg",
        title: "Anti Skid Tiles"
    },
    {
        href: "/tiles/cool-tiles",
        src: "COOL ROOF TILES.jpg",
        title: "Cool Roof Tiles"
    },
    {
        href: "/tiles/elevation-tiles",
        src: "ELEVATION TILES.jpg",
        title: "Elevation Tiles"
    },
    {
        href: "/tiles/highlighter-tiles",
        src: "/HIGHLIGHTER TILES.jpg",
        title: "Highlighter Tiles"
    },
    // {
    //   href: "/tiles/forever-tiles",
    //   src: "/SCRATCH FREE TILES.jpg",
    //   title: "Scratch Free Tiles(Forever Tiles)",
    // },
    {
        href: "/tiles/large-tiles",
        src: "/LARGE SLAB TILES.jpg",
        title: "Large Slab Tiles"
    }
];
function latestTrendingDesktop(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "home-color-tile-row",
        children: tileData.map((param, index)=>/*#__PURE__*/ {
            let { href , src , title , className =""  } = param;
            return (0,jsx_runtime.jsx)("div", {
                className: "home-color-tile-col ".concat(className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: href,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "find-color-img",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: src,
                                alt: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "find-color-text",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: title
                            })
                        })
                    ]
                })
            }, index);
        })
    });
}
/* harmony default export */ var homepage_latestTrendingDesktop = (latestTrendingDesktop);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/visualSearch2.js
var visualSearch2 = __webpack_require__(96910);
;// CONCATENATED MODULE: ./pages/index.js



const TrendingTiles = dynamic_default()(()=>__webpack_require__.e(/* import() */ 7313).then(__webpack_require__.bind(__webpack_require__, 47313)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(47313)
            ]
    }
});
const MainSlider = dynamic_default()(()=>__webpack_require__.e(/* import() */ 8683).then(__webpack_require__.bind(__webpack_require__, 48683)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(48683)
            ]
    }
});
// const MobileMainSlider =dynamic(()=>import("../src/components/homepage/mobileMainSlider")) ;
const CustomerReview = dynamic_default()(()=>__webpack_require__.e(/* import() */ 88).then(__webpack_require__.bind(__webpack_require__, 90088)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(90088)
            ]
    }
});






const HomeTrilook = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9664).then(__webpack_require__.bind(__webpack_require__, 49664)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(49664)
            ]
    }
});

const HomePage = (data)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const [latestUpdateData, setLatestUpdateData] = (0,react.useState)(data.latestUpdates.latest_updates);
    const [relatedBlogData, setRelatedBlogData] = (0,react.useState)(data.blogData.slice(0, 2));
    const [displayAllCategories, setDisplayAllCategories] = (0,react.useState)(false);
    // const [relatedBlogData, setRelatedBlogData] = useState("");
    const [scrrenType, setScreenType] = (0,react.useState)("desktop");
    const [base64content, setbase64content] = (0,react.useState)("");
    const router = (0,next_router.useRouter)();
    const webPageSchema = ()=>{
        return {
            __html: '\n      {\n        "@context": "https://schema.org",\n        "@type": "WebPage",\n        "url": "https://staging.orientbell.com/",\n        "headline":"",\n            "breadcrumb": "",\n         "name": "Best Tiles Company in India - Leading Tile Brand | Orientbell Tiles",\n        "description": "Explore Orientbell, India\'s leading tile brand, with 100% Tiles, 0% Celebs. Get style & class with a wide range of premium quality tiles at the best price. Shop now!"\n    }\n      '
        };
    };
    const searchSchema = ()=>{
        return {
            __html: '{\n"@context": "https://schema.org/",\n"@type": "WebSite",\n"name": "Orientbell Tiles",\n"url": "https://staging.orientbell.com/",\n"potentialAction": {\n"@type": "SearchAction",\n"target": "https://staging.orientbell.com/catalogsearch/result?q={search_term_string}",\n"query-input": "required name=search_term_string"\n}\n}'
        };
    };
    (0,react.useEffect)(()=>{
    // if(window.matchMedia('(max-width: 768px)').matches){
    //   setScreenType("mobile")
    // } else {
    //   setScreenType("desktop")
    // }
    }, []);
    const [homePageData] = (0,react.useState)(data.data.cmsBlocks);
    // console.log("XYZZZZ",data.data.cmsBlocks )
    // Function to convert image to base64
    const convertToBase64 = (file)=>{
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = ()=>resolve(reader.result);
            reader.onerror = (error)=>reject(error);
        });
    };
    // Handle file selection and validate MIME type
    const handleFileChange = async (event)=>{
        const file = event.target.files[0];
        // Check if a file is selected
        if (file) {
            try {
                const base64String = await convertToBase64(file);
                setbase64content(base64String);
                // console.log('Base64 type:', base64String.split(',')[0]); // Debugging purpose
                // console.log('Base64 String:', base64String.split(',')[1]); // Debugging purpose
                event.target.value = null;
            // Now you can use base64String for your API call
            } catch (error) {
                console.log("Error converting image to base64:", error);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Best Tiles Company in India - Leading Tile Brand | Orientbell Tiles"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: "Best Tiles Company in India - Leading Tile Brand | Orientbell Tiles"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Orientbell Tiles is a top tiles company in india offering 100% Tiles and 0% Celebs. Explore a wide range of premium quality tiles at the best price in your city. Shop Online!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "orientbell, orientbell tiles, orientbell tiles manufacturer, tiles largest manufacturer, best tile manufacturer in india"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "INDEX,FOLLOW"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "format-detection",
                        content: "telephone=no"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "pinterest-rich-pin",
                        content: "false"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: "Explore Orientbell, India's leading tile brand, with 100% Tiles, 0% Celebs. Get style & class with a wide range of premium quality tiles at the best price. Shop now!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:url",
                        content: "/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/twitterLogo.jpg")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "Orientbell"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:creator",
                        content: "Orientbell"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "Best Tiles Company in India - Leading Tile Brand | Orientbell Tiles"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Best Tiles Company in India - Leading Tile Brand | Orientbell Tiles"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "Explore Orientbell, India's leading tile brand, with 100% Tiles, 0% Celebs. Get style & class with a wide range of premium quality tiles at the best price. Shop now!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://staging.orientbell.com/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/twitterLogo.jpg")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        hrefLang: "en-in",
                        href: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: webPageSchema()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: searchSchema()
                    })
                ]
            }),
            base64content && /*#__PURE__*/ (0,jsx_runtime.jsx)(visualSearch2/* default */.Z, {
                base64: base64content,
                setbase64content: setbase64content
            }),
            scrrenType == "desktop" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "desktopMainSlider_home_page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MainSlider, {
                        data: (ref = homePageData.items[1]) === null || ref === void 0 ? void 0 : ref.content
                    }),
                    " "
                ]
            }),
            scrrenType == "mobile" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "MobileMainSlider_home_page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMainSlider, {
                        data: (ref1 = homePageData.items[10]) === null || ref1 === void 0 ? void 0 : ref1.content
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "oblhome-category-section new-design-mobileview",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "oblhome-category-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "oblhome-category-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figure",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/tiles/floor-tiles",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/floor-tiles-66f6ab2a37097.webp",
                                                    alt: "image"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figcation",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/tiles/floor-tiles",
                                                    children: "Floor Tiles"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "oblhome-category-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figure",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/tiles/wall-tiles",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/wall-tiles-66f6ab2ab81dd.webp",
                                                    alt: "image"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figcation",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/tiles/wall-tiles",
                                                    children: "Wall Tiles"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "oblhome-category-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figure",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/tiles/kitchen-tiles",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/kitchen-tiles-66f6ab28cbe8d.webp",
                                                    alt: "image"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figcation",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/tiles/kitchen-tiles",
                                                    children: "Kitchen Tiles"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "oblhome-category-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figure",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/tiles/bathroom-tiles",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/bathroom-tiles-66f6ab2a092c2.webp",
                                                    alt: "image"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figcation",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/tiles/bathroom-tiles",
                                                    children: "Bathroom Tiles"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "oblhome-category-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figure",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/tiles/wooden-tiles",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/wooden-tiles-66f6ab28202ee.webp",
                                                    alt: "image"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figcation",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/tiles/wooden-tiles",
                                                    children: "Wooden Tiles"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "oblhome-category-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figure",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/tiles/marble-tiles",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/marble-tiles-66f6ab2840b61.webp",
                                                    alt: "image"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figcation",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/tiles/marble-tiles",
                                                    children: "Marble Tiles"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: displayAllCategories ? "oblhome-category-col " : "oblhome-category-col remove-tiles",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figure",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/tiles/living-room-tiles",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/room-tiles-66f6ab29658ac.webp",
                                                    alt: "image"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figcation",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/tiles/living-room-tiles",
                                                    children: "Room Tiles"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: displayAllCategories ? "oblhome-category-col " : "oblhome-category-col remove-tiles",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figure",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/tiles/vitrified-tiles",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/vitrified-tile-66f6ab299833b.webp",
                                                    alt: "image"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figcation",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/tiles/vitrified-tiles",
                                                    children: "Vitrified Tiles"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: displayAllCategories ? "oblhome-category-col " : "oblhome-category-col remove-tiles",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figure",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/tiles/ceramic-tiles",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/ceramic-tiles-66f6ab27757ed.webp",
                                                    alt: "image"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figcation",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/tiles/ceramic-tiles",
                                                    children: "Ceramic Tiles"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: displayAllCategories ? "oblhome-category-col " : "oblhome-category-col remove-tiles",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figure",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/tiles/cool-tiles",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/cool-tiles-66f6ab2905c12.webp ",
                                                    alt: "image"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figcation",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/tiles/cool-tiles",
                                                    children: "Cool Tiles"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: displayAllCategories ? "oblhome-category-col " : "oblhome-category-col remove-tiles",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figure",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/tiles/large-tiles",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/large-tiles-66f6ab27a9099.webp ",
                                                    alt: "image"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "oblhome-category-figcation",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "/tiles/large-tiles",
                                                    children: "Large Tiles"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        !displayAllCategories ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            class: "view-all-category-btn",
                            onClick: ()=>setDisplayAllCategories(true),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "View More"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            class: "view-all-category-btn",
                            onClick: ()=>setDisplayAllCategories(false),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "View Less"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "largest-collection-section new-design-mobileview",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: " Large Tiles "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mobile-latest-sction",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_largeCollectionMobileSlider, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "obl-LatestTrending-section new-design-mobileview",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Explore Our Range"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Tiles for your home decor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mobile-latest-sction",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_latestTrending, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeTrilook, {
                content: (ref2 = homePageData.items[0]) === null || ref2 === void 0 ? void 0 : ref2.content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "home-color-tile-section explore-range-section-desktop",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "home-color-tile",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Explore Our Range"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Tiles for your home decor"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "latest-trending",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_latestTrendingDesktop, {})
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "home_features hp-features",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    dangerouslySetInnerHTML: {
                        __html: (ref3 = homePageData.items[3]) === null || ref3 === void 0 ? void 0 : ref3.content
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "home-color-tile-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "home-color-tile",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Find Your Color"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "From subtle elegance to bold statements"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "home-color-tile-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "home-color-tile-col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "/tiles/white-tiles",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-img",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "White.webp",
                                                    alt: "image"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-text",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "Whites"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "home-color-tile-col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "/tiles/blue-tiles",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-img",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "Blue.webp",
                                                    alt: "image"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-text",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "Blues"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "home-color-tile-col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "/tiles/grey-tiles",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-img",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "Grey.webp",
                                                    alt: "image"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-text",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "Greys"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "home-color-tile-col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "/tiles/green-tiles",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-img",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "Green.webp",
                                                    alt: "image"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-text",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "Greens"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "home-color-tile-col lastchild-color-bx",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "/tiles/pink-tiles",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-img",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "Pink.webp",
                                                    alt: "image"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-text",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "Pinks"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "shop-all-solor-btn",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/shop-by-color",
                                className: "default-btn shop-all-btn",
                                children: "Shop Tiles By Color"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "same_look",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "same_look_wrap flex-css",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "same_look_img",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Looking for a specific pattern/color ?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "../similar-look-home.webp",
                                        alt: "image"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "default-btn --syte-start-camera-upload hide-sm",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: [
                                                "Discover Similar Tiles",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "file",
                                                    accept: "image/jpeg, image/png, image/tiff" // Restrict the accepted file types
                                                    ,
                                                    onChange: handleFileChange,
                                                    style: {
                                                        display: "none"
                                                    }
                                                })
                                            ]
                                        })
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "same_look_data",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Looking for a specific pattern/color ?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "We help you visually search for similar color or design patterns. Check it out now"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "default-btn --syte-start-camera-upload hide-sm",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: [
                                                "Discover Similar Tiles",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "file",
                                                    accept: "image/jpeg, image/png, image/tiff" // Restrict the accepted file types
                                                    ,
                                                    onChange: handleFileChange,
                                                    style: {
                                                        display: "none"
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "home-color-tile-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "home-color-tile",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Inspiring Home Design Ideas Awaits! "
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Discover unique home design ideas to elevate interiors and exteriors with style, comfort and personal touch."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "home-color-tile-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "home-color-tile-col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "/design-ideas/bathroom-designs",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-img",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "https://server.orientbell.com/media/design_page/bathroom_desings/600x360%20Pix_0019_ODH_TABLON_BROWN_HL_ODG_TABLON_BROWN_&_ODG_TABLON_BEIGE_300x450_MM.webp",
                                                    alt: "image"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-text",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "Bathroom Design"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "home-color-tile-col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "/design-ideas/kitchen-designs",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-img",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "https://server.orientbell.com/media/design_page/kitchen_designs/600x360_Pix_0010_DR_Decor_Moroccan_DK_600x1200_mm.webp",
                                                    alt: "image"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-text",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "Kitchen Design "
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "home-color-tile-col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "/design-ideas/living-room-designs",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-img",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "https://server.orientbell.com/media/design_page/living_room_desings/600x360_Pix__0009_Dr_Gloss_Decor_Morrocan_Art_Blu_.webp",
                                                    alt: "image"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-text",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "Living Room Design "
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "home-color-tile-col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "/design-ideas/bedroom-designs",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-img",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "https://server.orientbell.com/media/design_page/bedroom_designs/600x360%20Pix_0017_CARVING_METAL_BRECCIA_MARBLE.webp",
                                                    alt: "image"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-text",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "Bedroom Design "
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "home-color-tile-col lastchild-color-bx",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "/design-ideas/pooja-room-designs",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-img",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "https://server.orientbell.com/media/design_page/pooja_room_desings/600x360_Pix__0004_OHG_Rhomboid_Rhomboid_Creama_300x450mm.webp",
                                                    alt: "image"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "find-color-text",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "Pooja Room Design "
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "shop-all-solor-btn",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/design-ideas",
                                className: "default-btn shop-all-btn",
                                children: "View All Designs"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "home_clients client-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    dangerouslySetInnerHTML: {
                        __html: (ref4 = homePageData.items[6]) === null || ref4 === void 0 ? void 0 : ref4.content
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "signature_iframe signature-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    dangerouslySetInnerHTML: {
                        __html: (ref5 = homePageData.items[8]) === null || ref5 === void 0 ? void 0 : ref5.content
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "latest-updates-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: "Latest Updates"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "latest-up-row flex-class",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "latest-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/latest-news",
                                                rel: "nofollow",
                                                children: "Media"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "home-listwrap flex-class",
                                            children: (ref6 = latestUpdateData.latestmedia) === null || ref6 === void 0 ? void 0 : ref6.map((obj, index)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "home-post",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "listingImg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: obj.read_more_url,
                                                                rel: "nofollow",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: obj.thumbnailimage,
                                                                    alt: "image"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "listingText",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: obj.read_more_url,
                                                                    className: "post-tiles",
                                                                    rel: "nofollow",
                                                                    children: obj.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: obj.short_content
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "listingButton",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                        href: obj.read_more_url,
                                                                        rel: "nofollow",
                                                                        children: [
                                                                            "Read More",
                                                                            " ",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                className: "fa fa-long-arrow-right",
                                                                                "aria-hidden": "true"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "latest-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/blog",
                                                rel: "nofollow",
                                                children: "Blog"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "home-listwrap flex-class",
                                            children: (relatedBlogData === null || relatedBlogData === void 0 ? void 0 : relatedBlogData.length) > 0 && Array.isArray(relatedBlogData) && relatedBlogData.map((obj, index)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "home-post",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "listingImg",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: obj.permalink,
                                                                rel: "nofollow",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: obj.image,
                                                                    alt: "image"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "listingText",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: obj.permalink,
                                                                    className: "post-tiles",
                                                                    rel: "nofollow",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: obj.title
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: obj.content
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "listingButton",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                        href: obj.permalink,
                                                                        rel: "nofollow",
                                                                        children: [
                                                                            "Read More",
                                                                            " ",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                className: "fa fa-long-arrow-right",
                                                                                "aria-hidden": "true"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (HomePage);


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 66611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createWithBsPrefix; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/camelize.js
var rHyphen = /-(.)/g;
function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js





const pascalCase = str => str[0].toUpperCase() + camelize(str).slice(1);
// TODO: emstricten & fix the typing here! `createWithBsPrefix<TElementType>...`
function createWithBsPrefix(prefix, {
  displayName = pascalCase(prefix),
  Component,
  defaultProps
} = {}) {
  const BsComponent = /*#__PURE__*/react.forwardRef(({
    className,
    bsPrefix,
    as: Tag = Component || 'div',
    ...props
  }, ref) => {
    const componentProps = {
      ...defaultProps,
      ...props
    };
    const resolvedPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, prefix);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag, {
      ref: ref,
      className: classnames_default()(className, resolvedPrefix),
      ...componentProps
    });
  });
  BsComponent.displayName = displayName;
  return BsComponent;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4585,6212,2770,5063,7528,6910,9774,2888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);